import React from "react";
import { RatingReviewsComponent } from "../components/RatingReviews/RatingReviewsComponent";
import styles from "./ShoppingProduct.module.scss";
import backSvg from "./backBtn.svg";
import { ColorSelect } from "./ColorSelect";
import { SwitchBar } from "../components/SwitchBar/SwitchBar";
import { Img } from "../ImgV2/Img";
export function ShoppingProduct(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SwitchBar, {
    sliderCount: props.product_list.length
  }, props.product_list.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ShoppingProductItemView, {
      key: index,
      item: item
    });
  })));
}
export function ShoppingProductItemView(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.itemBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconBox
  }, /*#__PURE__*/React.createElement(Img, {
    imgKey: props.item.product_image,
    className: "shoppingProductIconImg"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.contentBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, props.item.product_name), /*#__PURE__*/React.createElement("div", {
    className: styles.priceBox
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.price
  }, props.item.product_price), /*#__PURE__*/React.createElement(RatingReviewsComponent, {
    rating: " ".concat(props.item.product_rating, " "),
    reviews: "(".concat(props.item.product_reviews, " reviews)")
  })), /*#__PURE__*/React.createElement(ColorSelect, null), /*#__PURE__*/React.createElement("button", {
    className: styles.payBtn
  }, props.item.buy_button), /*#__PURE__*/React.createElement("div", {
    className: styles.merchantBox
  }, /*#__PURE__*/React.createElement("img", {
    src: props.item.source.source_icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.merchantName
  }, props.item.source.source_text))), props.showBackBtn && /*#__PURE__*/React.createElement("img", {
    src: backSvg,
    className: styles.back,
    onClick: function onClick() {
      var _props$tapBackBtn;
      (_props$tapBackBtn = props.tapBackBtn) === null || _props$tapBackBtn === void 0 || _props$tapBackBtn.call(props);
    }
  }));
}